// Clock times on the Live Attendance page. The API and database keep 24-hour "HH:MM" (20:48);
// everything a person reads or sets is 12-hour (08:48 PM). Durations such as worked hours and OT
// are not clock times and do not go through here.

const TIME_RE = /^(\d{1,2}):(\d{2})(?::\d{2})?$/;

export const pad2 = (n) => String(n).padStart(2, "0");

// "20:48" -> { hour: 8, minute: 48, period: "PM" }. Anything that is not a time -> null.
export function parseTime(value) {
  const match = TIME_RE.exec(String(value || "").trim());
  if (!match) return null;
  const h = Number(match[1]);
  const minute = Number(match[2]);
  if (h > 23 || minute > 59) return null;
  return { hour: h % 12 || 12, minute, period: h < 12 ? "AM" : "PM" };
}

// (8, 48, "PM") -> "20:48"
export function toStored(hour, minute, period) {
  return `${pad2((hour % 12) + (period === "PM" ? 12 : 0))}:${pad2(minute)}`;
}

// "20:48" -> "08:48 PM". Blank stays blank.
export function time12(value) {
  const t = parseTime(value);
  return t ? `${pad2(t.hour)}:${pad2(t.minute)} ${t.period}` : value || "";
}
